"use strict";

exports.__esModule = true;
exports.Connection = void 0;
const Connection = exports.Connection = {
  make: ({
    properties = {},
    data = {},
    behaviors = {}
  } = {}) => ({
    properties,
    data,
    behaviors
  })
};
//# sourceMappingURL=connection.js.map